// Add your custom JS here.



/*
document.addEventListener("DOMContentLoaded", function () {

    if (!document.body.classList.contains('page-template-calendar')) return;

    // Obtenir la date actuelle au format Ymd
    const today = new Date();
    //const today = new Date(2024, 11, 20);
    const todayYmd = today.getFullYear() * 10000 + (today.getMonth() + 1) * 100 + today.getDate();

    // Sélectionner toutes les cases de l'avent
    const cards = document.querySelectorAll(".avent-card");
    let closestCard = null;
    let closestDateDiff = Infinity;

    // Parcourir chaque case et trouver la plus proche de la date du jour
    cards.forEach(card => {
        const unlockDate = parseInt(card.getAttribute("data-date"));
        const dateDiff = Math.abs(unlockDate - todayYmd);

        // Si cette date est la plus proche de la date actuelle, on la stocke
        if (dateDiff < closestDateDiff) {
            closestDateDiff = dateDiff;
            closestCard = card;
        }
    });

    // Faire défiler jusqu'à la case la plus proche
    if (closestCard) {
        closestCard.scrollIntoView({
            behavior: "smooth",
            block: "center"
        });
    }
});
*/


function formatDate(dateString) {
    // Récupérer l'année, le mois et le jour depuis la chaîne de caractères
    const year = dateString.slice(0, 4);
    const month = dateString.slice(4, 6);
    const day = dateString.slice(6, 8);

    // Tableau des mois en français
    const months = [
        "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
        "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
    ];

    // Convertir la date en format "7 Décembre 2024"
    const formattedDate = `${parseInt(day)} ${months[parseInt(month) - 1]}`;

    return formattedDate;
}



document.addEventListener("DOMContentLoaded", function () {
    // Vérifie si c'est la page template "calendar"
    if (!document.body.classList.contains('page-template-calendar')) return;

    // Ajout d'un écouteur d'événements sur les cases verrouillées
    document.querySelectorAll('.locked').forEach((div) => {
        div.addEventListener('click', function handleClick() {
            // Si la case est déjà en train d'afficher la modal, on ignore le clic
            if (div.classList.contains('clicking')) return;

            // Ajoute une classe pour un effet visuel temporaire
            div.classList.add('clicking');

            // Récupère la date de la case parente
            const parentDiv = div.closest('[data-date]');
            const unlockDate = parentDiv ? parentDiv.getAttribute('data-date') : null;

            // Supprime la classe après 750ms et affiche la modal
            setTimeout(() => {
                div.classList.remove('clicking');

                // Met à jour dynamiquement le contenu de la modal avec la date
                if (unlockDate) {
                    document.querySelector('#modalTooLate .modal-date').textContent = formatDate(unlockDate);
                }

                // Affiche la modal Bootstrap
                const myModal = new bootstrap.Modal(document.getElementById('modalTooLate'), {
                    keyboard: true
                });
                myModal.show();

                // Réactive le clic sur la case après la fermeture de la modal
                myModal._element.addEventListener('hidden.bs.modal', () => {
                    div.addEventListener('click', handleClick);
                });

                // Désactive le clic sur la case pendant l'affichage de la modal
                div.removeEventListener('click', handleClick);
            }, 750);
        });
    });
});




// Fonction pour charger les confettis avec canvas-confetti

function loadSnow() {
    function randomInRange(min, max) {
        return Math.random() * (max - min) + min;
    }

    let animationFrame;

    function launchConfetti() {
        confetti({
            particleCount: 1,
            startVelocity: 0,
            ticks: Math.max(200, 500),
            origin: {
                x: Math.random(),
                y: Math.random() * 0.8 - 0.2, // since particles fall down, skew start toward the top
            },
            colors: ["#ffffff"],
            shapes: ["circle"],
            gravity: randomInRange(0.4, 0.6),
            scalar: randomInRange(0.4, 1),
            drift: randomInRange(-0.4, 0.4),
        });

        animationFrame = requestAnimationFrame(launchConfetti);
    }

    // Démarre l'animation
    launchConfetti();

    // Retourne une fonction pour arrêter l'animation
    return () => cancelAnimationFrame(animationFrame);
}



document.addEventListener('DOMContentLoaded', function () {

    if (!document.body.classList.contains('single-fff_aventday')) return;

    const dayWrapper = document.querySelector('#day-wrapper');
    const caseId = dayWrapper?.getAttribute('data-case-id'); // Récupère l'ID du data-attribute
    let stopSnow = null; // Variable pour stocker la fonction d'arrêt de la neige

    if (!caseId) {
        console.error('Case ID not found on #day-wrapper');
        return; // Arrête l'exécution si l'ID est introuvable
    }

    // Fonction pour lire un cookie
    function getCookie(name) {
        let cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            let cookie = cookies[i].trim();
            if (cookie.startsWith(name + '=')) {
                return cookie.substring(name.length + 1);
            }
        }
        return null;
    }

    // Vérifie si `visited_cases` contient `caseId`
    const cookieName = 'visited_cases';
    let visitedCases = getCookie(cookieName);

    if (visitedCases) {
        visitedCases = JSON.parse(visitedCases);
        if (visitedCases.includes(caseId)) {
            dayWrapper.classList.remove('snowing'); // Retire la classe `snowing`
        }
    }

    // Initialisation du MutationObserver pour surveiller les changements de classes
    if (dayWrapper) {
        const observer = new MutationObserver(() => {
            if (dayWrapper.classList.contains('snowing')) {
                // Démarre la neige si la classe `snowing` est ajoutée
                if (!stopSnow) {
                    stopSnow = loadSnow();
                }
            } else {
                // Arrête la neige si la classe `snowing` est retirée
                if (stopSnow) {
                    stopSnow();
                    stopSnow = null;
                }
            }
        });

        // Observer uniquement les changements d'attributs (comme les classes)
        observer.observe(dayWrapper, { attributes: true, attributeFilter: ['class'] });

        // Lancer la neige immédiatement si `snowing` est présent au chargement
        if (dayWrapper.classList.contains('snowing')) {
            stopSnow = loadSnow();
        }
    }
});



document.addEventListener('DOMContentLoaded', function () {

    if (!document.body.classList.contains('single-fff_aventday')) return;

    const parentDiv = document.querySelector('.parent');
    const dot = document.querySelector('.dotDraggable');
    const stroke = document.querySelector('.swiperDraggable');
    const childDiv = document.querySelector('.child');
    const contentBlock = document.querySelector('.contentBlock');
    const dayWrapper = document.querySelector('#day-wrapper');
    const caseId = dayWrapper?.getAttribute('data-case-id'); // Récupère l'ID du data-attribute

    let isDragging = false;
    let startX = 0;
    let currentX = 0;
    let initialPosition = 0; // Position initiale du dot

    // Fonction pour lire un cookie
    function getCookie(name) {
        let cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            let cookie = cookies[i].trim();
            if (cookie.startsWith(name + '=')) {
                return cookie.substring(name.length + 1);
            }
        }
        return null;
    }

    // Fonction pour définir un cookie
    function setCookie(name, value, days) {
        let date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        let expires = 'expires=' + date.toUTCString();
        document.cookie = name + '=' + value + ';' + expires + ';path=/';
    }

    // Fonction pour agrandir la div parent et déclencher les confettis
    function triggerExpansion() {
        
        parentDiv.classList.add('wiggleState');
        childDiv.classList.add('no-animation'); // Cache le child

        setTimeout(() => {
            parentDiv.classList.add('no-animation');
            parentDiv.classList.remove('wiggleState');
            parentDiv.classList.add('expanded-full');
            childDiv.classList.add('hidden'); // Cache le child
            loadConfetti();
            setTimeout(() => {
                contentBlock.classList.add('show');
            }, 500);
        }, 1000);

        

    }

    // Fonction pour charger les confettis
    function loadConfetti() {
        const defaults = {
            spread: 360,
            ticks: 300,
            gravity: 1,
            decay: 0.94,
            startVelocity: 30,
            shapes: ['star'],
            colors: ['#FFE400', '#FFBD00', '#E89400', '#FFCA6C', '#FDFFB8'],
        };

        function shoot() {
            confetti({
                ...defaults,
                particleCount: 40,
                scalar: 1.2,
                shapes: ['star'],
            });

            confetti({
                ...defaults,
                particleCount: 10,
                scalar: 0.75,
                shapes: ['circle'],
            });
        }

        setTimeout(shoot, 0);
        setTimeout(shoot, 100);
        setTimeout(shoot, 200);
    }

    // Gestion du swipe
    function handleSwipe() {
        const strokeWidth = stroke.offsetWidth;
        const dotPosition = currentX - startX;

        if (dotPosition > strokeWidth ) {

            // Si on dépasse 50% du stroke
            triggerExpansion();

            // Mise à jour du cookie
            const cookieName = 'visited_cases';
            let visitedCases = getCookie(cookieName);

            setTimeout(() => {
                if (visitedCases) {
                    visitedCases = JSON.parse(visitedCases);
                    if (!visitedCases.includes(caseId)) {
                        visitedCases.push(caseId);
                        dayWrapper.classList.remove('snowing');
                    }
                } else {
                    visitedCases = [caseId];
                    dayWrapper.classList.remove('snowing');
                }
                setCookie(cookieName, JSON.stringify(visitedCases), 30);
            }, 1500);
        }
    }

    function resetPosition() {
        dot.style.transition = 'transform 0.2s ease-out';  // Animation pour revenir à la position initiale
        dot.style.transform = `translateX(0)`; // Position initiale
    }

    // Événements tactiles et souris
    function startDrag(e) {
        isDragging = true;
        startX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
        initialPosition = dot.getBoundingClientRect().left; // Enregistre la position initiale
        stroke.classList.add('no-animation');
    }

    function moveDrag(e) {
        if (!isDragging) return;
        currentX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;

        const diff = currentX - startX;

        // Déplace le dot dans les limites du stroke
        if (diff >= 0 && diff <= stroke.offsetWidth) {
            dot.style.transform = `translateX(${diff}px)`;
        }
    }

    function endDrag() {
        if (!isDragging) return;
        isDragging = false;
        
        const dotPosition = currentX - startX;
        const strokeWidth = stroke.offsetWidth;

        if (dotPosition < strokeWidth) {
            // Si la position du dot est inférieure à 50% du stroke, il revient à la position initiale
            resetPosition();
            setTimeout(() => {
                stroke.classList.remove('no-animation');
            }, 200);
        } else {
            handleSwipe(); // Vérifie si le swipe est suffisant
        }
    }

    // Attache les événements
    dot.addEventListener('mousedown', startDrag);
    dot.addEventListener('touchstart', startDrag);

    window.addEventListener('mousemove', moveDrag);
    window.addEventListener('touchmove', moveDrag);

    window.addEventListener('mouseup', endDrag);
    window.addEventListener('touchend', endDrag);
});










// Spoiler alert

document.addEventListener('DOMContentLoaded', function () {

    if (!document.body.classList.contains('page-template-inscription') && !document.body.classList.contains('page-template-preinscription')) {
        return;
    }
    
    const draggableCases = document.querySelectorAll('.blockCard'); // Sélectionne toutes les cases

    draggableCases.forEach((caseElement) => {
        const dot = caseElement.querySelector('.dotDraggable');
        const stroke = caseElement.querySelector('.swiperDraggable');
        const parentDiv = caseElement.querySelector('.parent');
        const childDiv = caseElement.querySelector('.child');
        const contentBlocks = caseElement.querySelectorAll('.reveal');

        let isDragging = false;
        let startX = 0;
        let currentX = 0;

        // Fonction pour agrandir la div parent et déclencher les confettis
        function triggerExpansion() {
            parentDiv.classList.add('wiggleState');
            childDiv.classList.add('no-animation'); // Cache le child

            setTimeout(() => {
                parentDiv.classList.add('no-animation');
                parentDiv.classList.remove('wiggleState');
                dot.classList.add('hidden');
                stroke.classList.add('hidden');
                childDiv.classList.add('hidden'); // Cache le child
                loadConfetti();
                contentBlocks.forEach((contentBlock) => {
                    contentBlock.classList.remove('hidden');
                    contentBlock.classList.add('show');
                });
            }, 1000);
        }

        // Fonction pour charger les confettis
        function loadConfetti() {
            const canvas = document.getElementById('confetti-canvas');
            const defaults = {
                spread: 360,
                ticks: 300,
                gravity: 1,
                decay: 0.94,
                startVelocity: 30,
                shapes: ['star'],
                colors: ['#FFE400', '#FFBD00', '#E89400', '#FFCA6C', '#FDFFB8'],
            };
        
            // Redimensionne le canvas pour couvrir tout l'écran
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
        
            // Configure confetti pour utiliser ce canvas
            const confettiInstance = confetti.create(canvas, {
                resize: true, // Adapte automatiquement la taille du canvas si la fenêtre change
            });
        
            function shoot() {
                confettiInstance({
                    ...defaults,
                    particleCount: 40,
                    scalar: 1.2,
                    shapes: ['star'],
                });
        
                confettiInstance({
                    ...defaults,
                    particleCount: 10,
                    scalar: 0.75,
                    shapes: ['circle'],
                });
            }
        
            setTimeout(shoot, 0);
            setTimeout(shoot, 100);
            setTimeout(shoot, 200);
        }
        


        // Fonction pour vérifier le swipe
        function handleSwipe() {
            const strokeWidth = stroke.offsetWidth;
            const dotPosition = currentX - startX;

            if (dotPosition > strokeWidth) {
                triggerExpansion(); // Déclenche l'animation d'expansion
            }
        }

        function resetPosition() {
            dot.style.transition = 'transform 0.2s ease-out'; // Animation pour revenir à la position initiale
            dot.style.transform = `translateX(0)`; // Position initiale
        }

        // Événements tactiles et souris
        function startDrag(e) {
            isDragging = true;
            startX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
            stroke.classList.add('no-animation');
        }

        function moveDrag(e) {
            if (!isDragging) return;
            currentX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;

            const diff = currentX - startX;

            // Déplace le dot dans les limites du stroke
            if (diff >= 0 && diff <= stroke.offsetWidth) {
                dot.style.transform = `translateX(${diff}px)`;
            }
        }

        function endDrag() {
            if (!isDragging) return;
            isDragging = false;

            const dotPosition = currentX - startX;
            const strokeWidth = stroke.offsetWidth;

            if (dotPosition < strokeWidth) {
                // Si la position du dot est inférieure au stroke, il revient à la position initiale
                resetPosition();
                setTimeout(() => {
                    stroke.classList.remove('no-animation');
                }, 200);
            } else {
                handleSwipe(); // Vérifie si le swipe est suffisant
            }
        }

        // Attache les événements pour chaque élément
        dot.addEventListener('mousedown', startDrag);
        dot.addEventListener('touchstart', startDrag);

        window.addEventListener('mousemove', moveDrag);
        window.addEventListener('touchmove', moveDrag);

        window.addEventListener('mouseup', endDrag);
        window.addEventListener('touchend', endDrag);
    });
});


